module.exports = __webpack_public_path__ + "static/media/search.388b378a.svg";